import { useMe } from '../../hooks/queries'

/** Was rechts steht, solange kein Chat geöffnet ist. Am Telefon nie sichtbar. */
export function StartPane() {
  const me = useMe()

  return (
    <div className="empty">
      <p className="empty__title">Travel Broadcast</p>
      {me.data?.may_create_trips ? (
        <p>
          Wähle links eine Reise aus oder lege eine neue an.
          <br />
          Was du schreibst, lesen alle Empfänger. Was sie antworten, liest nur du.
        </p>
      ) : (
        <p>
          Wähle links eine Reise aus.
          <br />
          Deine Antworten liest nur der Reisende – die anderen Empfänger nicht.
        </p>
      )}
    </div>
  )
}
